<template>
  <c-modal
    class="c-blogPaidRequired"
    title="登録状況"
    :width="416"
    :active="isVisible"
    @close="$emit('close')"
  >
    <div class="c-blogPaidRequired_container">
      <div class="c-blogPaidRequired_head">
        <coconala-icon name="exclamation-circle"/>
        有料公開は以下の情報登録が必要です。
      </div>
      <div class="c-blogPaidRequired_information">
        <div
          class="c-blogPaidRequired_userInformation"
          :class="{ 'c-blogPaidRequired_userInformation-registered' : isProvider }"
        >
          <div>出品者情報</div>
          <div>
            <coconala-icon
              name="check"
              size="14px"
            />
            <span>{{ isProvider ? '登録済み' : '未登録' }}</span>
          </div>
          <div v-if="!isProvider">
            <a :href="userInformationRegisterUrl">登録する</a>
          </div>
        </div>
        <div
          class="c-blogPaidRequired_phoneNumber"
          :class="{ 'c-blogPaidRequired_phoneNumber-registered' : smsAuthenticationFg }"
        >
          <div>電話番号</div>
          <div>
            <coconala-icon
              name="check"
              size="14px"
            />
            <span>{{ smsAuthenticationFg ? '登録済み' : '未登録' }}</span>
          </div>
          <div v-if="!smsAuthenticationFg">
            <NuxtLink :to="smsRegisterUrl">登録する</NuxtLink>
          </div>
        </div>
      </div>
      <div class="c-blogPaidRequired_action">
        <c-button-v2
          size="m"
          width="200px"
          color="thirdly"
          @click="$emit('close')"
        >閉じる</c-button-v2>
      </div>
    </div>
  </c-modal>
</template>
<script>
export default {
  name: 'BlogPaidRequiredModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    isProvider: {
      type: Boolean,
      default: false
    },
    smsAuthenticationFg: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userInformationRegisterUrl() {
      return this.$coconala.url('/mypage/user_information', { redirect_to: '/mypage/blogs' })
    },
    smsRegisterUrl() {
      return '/mypage/sms?redirect_to=/mypage/blogs'
    }
  }
}
</script>

<style lang="scss" scoped>
.c-blogPaidRequired {
  /deep/ .c-modal {
    &_inner {
      overflow: visible !important;
    }
    &_body {
      max-height: inherit;
      overflow: visible !important;
    }
  }

  &_container {
    margin: 8px 30px 16px;
  }

  &_head {
    font-size: 16px;
    font-weight: bold;
    color: $color-gray-900;
  }

  &_subHead {
    margin-top: 8px;
  }

  &_information {
    margin-top: 24px;
    border-top: 1px solid $color-gray-300;
    border-bottom: 1px solid $color-gray-300;
  }

  &_userInformation {
    display: flex;
    padding: 16px 12px;
    border-bottom: 1px dashed $color-gray-200;

    div {
      width: 30%;
    }

    i {
      vertical-align: -3px;
      font-size: 15px;
      color: $color-gray-400;
    }

    &-registered {
      i {
        color: $color-deep-green-500;
      }
    }
  }

  &_phoneNumber {
    display: flex;
    padding: 16px 12px;

    div {
      width: 30%;
    }

    i {
      vertical-align: -3px;
      font-size: 15px;
      color: $color-gray-400;
    }

    &-registered {
      i {
        color: $color-deep-green-500;
      }
    }
  }

  &_antiCompnyUnderExamination {
    margin-top: 16px;
    padding: 8px 12px 8px 20px;
    font-size: 13px;
    background-color: $color-yellow-50;
  }

  &_action {
    display: flex;
    justify-content: center;
    margin-top: 24px;

    button {
      width: 128px;
    }
  }

  &_draftBtn {
    margin-right: 12px;
    color: $color-gray-600;
  }
}
</style>
